var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_7783)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54_7783",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.14441e-05H24V24H0V1.14441e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54_7783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2188 4.62503C21.2188 6.66156 19.5678 8.3125 17.5313 8.3125C15.4947 8.3125 13.8438 6.66156 13.8438 4.62503C13.8438 2.5885 15.4947 0.937518 17.5313 0.937518C19.5678 0.937518 21.2188 2.5885 21.2188 4.62503Z",
    stroke: "#C1E2E6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4533 9.24725C15.3332 8.65686 16.392 8.31247 17.5312 8.31247C20.5859 8.31247 23.0623 10.7888 23.0623 13.8435V15.6875H0.9375",
    stroke: "#C1E2E6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1562 4.62491C10.1562 6.66144 8.50525 8.31238 6.46872 8.31238C4.43219 8.31238 2.78125 6.66144 2.78125 4.62491C2.78125 2.58838 4.43219 0.937396 6.46872 0.937396C8.50525 0.937396 10.1562 2.58838 10.1562 4.62491Z",
    stroke: "#C1E2E6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 15.6875V13.8435C0.9375 10.7888 3.41386 8.31247 6.46856 8.31247C7.60777 8.31247 8.66648 8.65691 9.54637 9.24721",
    stroke: "#C1E2E6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 12C15.6875 14.0365 14.0365 15.6875 12 15.6875C9.96344 15.6875 8.3125 14.0365 8.3125 12C8.3125 9.96346 9.96344 8.31247 12 8.31247C14.0365 8.31247 15.6875 9.96346 15.6875 12Z",
    stroke: "#C1E2E6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5314 23.0625V21.2186C17.5314 18.1638 15.055 15.6875 12.0003 15.6875C8.94564 15.6875 6.46924 18.1638 6.46924 21.2186V23.0625H17.5314Z",
    stroke: "#C1E2E6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_7783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/Customer.c9f00e32d7b90c0791f0e044c74f2bea.svg";
export { ForwardRef as ReactComponent };